/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs */

const es_components_upgrade_plan_modal_features_storage_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento ilimitado`)
};

const en_components_upgrade_plan_modal_features_storage_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited storage`)
};

/**
* | output |
* | --- |
* | "Unlimited storage" |
*
* @param {Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_storage_unlimited = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_Storage_UnlimitedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_storage_unlimited(inputs)
	return en_components_upgrade_plan_modal_features_storage_unlimited(inputs)
});
export { components_upgrade_plan_modal_features_storage_unlimited as "components.upgrade_plan_modal.features.storage_unlimited" }